/* eslint-disable @typescript-eslint/no-deprecated */
export type { AlertProps, AlertSlots, AlertState } from './components/Alert/index';
export {
  Alert,
  alertClassNames,
  renderAlert_unstable,
  useAlertStyles_unstable,
  useAlert_unstable,
} from './components/Alert/index';
